import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import leadsSaga from './leads/saga'

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    leadsSaga(),
  ]);
}
